import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { CampaignStore } from './campaign.store.types';

import { CampaignTab } from 'shared/legacy/contexts/SelectedCampaignContext/SelectedCampaignContext.types';

export const useCampaignStore = create<CampaignStore>()(
  devtools(
    (set) => ({
      campaign: null,
      selectedTab: CampaignTab.New,

      setCampaign: (campaign) => set(() => ({ campaign })),
      setSelectedTab: (selectedTab) => set(() => ({ selectedTab })),
    }),
    { name: 'CampaignStore' },
  ),
);
